import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import {AgGridReact} from "ag-grid-react";

import 'ag-grid-enterprise';

import searchImg from "@images/new/search.svg";
import settingsImg from "@images/new/settings.svg";

import ModalCard from "@elements/modalCard/ModalCard";

import './treeStyle.scss';
import st from './treeStyle.module.scss';
import { ApplicationContext } from "@pages/monitoring/map/MapPage";
import { map, record, string } from "fp-ts";
import { AsObjectHashMap } from "@context/map/utilMutableStore";
import { HashElement } from "@context/map/units/unitsStore";
import { KAryTreeNode } from "@baseTypes/baseType";


const TreeList = memo((props: any) => {
  let {
    nodes = [],
    group: Group,
    element: Element,
    selected = [],
    contextMenu,
    
  } = props
  
  let treeList = useRef<any>()
  let settingIcon = useRef<any>()
  let [activeModal, setActiveModal] = useState(false)
  
  let [externalFilter, setExternalFilter] = useState("")
  
  useEffect(() => {
    treeList?.current?.api?.onFilterChanged();
  }, [externalFilter])

  useEffect(() => {
    let firstElement = true
    treeList?.current?.api?.forEachNode((node: any) => {
      selected.forEach((i: any) => {
        
        if (i.glid === node.data.glid && firstElement) {
          treeList?.current?.api.ensureIndexVisible(node.rowIndex)
          firstElement = false
        }
        node.setSelected(i.glid === node.data.glid)
      })
    })
    
    
  }, [selected])
  
  const autoGroupColumnDef = {
    headerName: "",
    flex: 1,
    minWidth: 400,
    selectable: true,
    resizable: true,
    cellRendererParams: {
      suppressCount: false,
      suppressPadding: false,
      innerRenderer: (params: any) => {
        let {data, node} = params
        return (
          <>
            {data?.data
              ? <Group data={data}/>
              : <Element data={data}/>
            }
          </>
        )
      }
    }
  };
  
  const columnDefs = [
    {field: "tableName", headerClass: st.hidden_header},
    {field: 'glid', hide: true, disable: true}
  ]
  
  
  function getContextMenuItems(params: any) {
    return contextMenu().map((itemMenu: any) => {
      let {name, action, tooltip} = itemMenu
      if (name === "-") return "separator"
      
      return {
        name: name,
        action: () => action(params),
        // cssClasses: [st.menuItem],
        // tooltip
      }
    })
  }
  
  const gridOptions = {
    
    columnDefs: columnDefs,
    headerHeight: 0,
    groupDisplayType: "singleColumn",
    debounceVerticalScrollbar: true,
    autoGroupColumnDef: autoGroupColumnDef,
    treeData: true,
    animateRows: true,
    groupDefaultExpanded: -1,
    cacheQuickFilter: true,
    rowSelection: 'multiple',
    defaultColDef: {
      // skipHeader:true
      // minWidth: 414,
      maxWidth: '100%',
      // selectable: true,
      // allowContextMenuWithControlKey: true,
      // suppressMenu: false,
      // sortable: false,
      filter: true,
      // resizable: true,
      // getContextMenuItems: getContextMenuItems,
      headerComponentParams: {
        template: `<div></div>`,
      },
    },
  }
  return (
    <>
      <div className={st.container}>
        <div className={st.finder}>
          <div className={st.input}>
            <img src={searchImg} className={st.svg}/>
            <input type={"text"} placeholder={"Поиск"} className={st.search}
                   onChange={(v: any) => setExternalFilter(v.target.value)}/>
          </div>
          <div className={st.icon}>
            <img
              src={settingsImg}
              className={st.svg}
              ref={settingIcon}
              onClick={() => setActiveModal(true)}
            />
          </div>
          {activeModal && <>
            <ModalCard
              header={"Настройки списка"}
              oncancel={() => setActiveModal(false)}
              onsave={() => ""}
              className={st.modal}
              style={{
                width: 393,
                height: 680,
                top: 0,
                left: "calc(100% + 12px)"
              }}
            >
              список строк
            </ModalCard>
          </>}
        </div>

        <div
          className={cn("ag-theme-list", st.list)}
          id={"treeList"}
        >
          {/*@ts-ignore*/}
          <AgGridReact
            // @ts-ignore
            ref={treeList}
            rowData={nodes}
            gridOptions={gridOptions}
            getDataPath={data => data.nameGroup || data.groupName}
            rowClass={st.row}
            getContextMenuItems={getContextMenuItems}
            isExternalFilterPresent={(params: any) => externalFilter}
            doesExternalFilterPass={(params: any) => {
              return (
                params.data.name.indexOf(externalFilter) === 0 ||
                params.data.glid.indexOf(externalFilter) === 0
              )
            }}
            rowHeight={50}
          />
        </div>
      </div>
    </>
  )
}, (prevProps: any, nextProps: any) => {
  return false
  // return prevProps.filters == nextProps.filters
  //   || prevProps.fields == nextProps.fields
  //   || prevProps.data == nextProps.data
})

export default TreeList;


//
// const filterHandler = (data: any): boolean => {
//   let bool = false
//   let intoObject = {}
//   fields.forEach((field: any) => {
//     let arrayFields = field.split(".")
//     arrayFields.forEach((item: any) => {
//       intoObject = data[item]
//       if (filters.includes(intoObject)) bool = true
//     })
//   })
//   return bool
// }


// const tree = (data: any,) => {
//   let {node} = data
//   index++
//   if (node?.data) {
//     // children || filterHandler(node) &&
//     return (
//       <>
//         <TreeGroup {...{...data, index}}>
//           {node.data.flatMap((item: any) => tree({...data, node: item, index}))}
//         </TreeGroup>
//       </>
//     )
//   }
//
//   if (filterHandler(node)) {
//     return [<TreeItem {...data} />]
//   }
//
//   return []
//
// }


///====================================++>
///====================================++>
///====================================++>
///====================================++>

// import React, {useState, useEffect, memo, useRef} from 'react';
//
// import 'react-virtualized/styles.css';
//
// import Tree, {selectors} from "react-virtualized-tree";
// import st from './treeStyle.module.scss';
// import './treeStyle.scss';
// import cn from 'classnames';
// import {AgGridReact} from "ag-grid-react";
// import 'ag-grid-enterprise';
// import {InputSwitch} from "primereact/inputswitch";
// import {IconBox, InputText} from "@infobis/ui-styles-utils";
// import searchImg from "@images/new/search.svg"
// import settingsImg from "@images/new/settings.svg"
// import ModalCard from "@components/custom/ModalCard/ModalCard";
//
//
// const TreeList = memo((props: any) => {
//
//   let {
//     data,
//     group: Group,
//     element: Element,
//     filters = [],
//     fields = [],
//     elemRef,
//     contextMenu,
//
//   } = props
//
//   let treeList = useRef<any>()
//   let settingIcon = useRef<any>()
//   let [activeModal, setActiveModal] = useState(false)
//
//   let [nodes, setNode] = useState<any>([]);
//   let [externalFilter, setExternalFilter] = useState("")
//
//   useEffect(() => {
//     treeList?.current?.api?.onFilterChanged();
//   }, [externalFilter])
//
//
//   useEffect(() => {
//     let tree = (data: any): any => {
//       let {nameGroup: copyNameGroup = []} = data
//       let nameGroup = [...copyNameGroup, data.glid]
//
//       if (data?.data) {
//         let list = data.data.flatMap((item: any) => tree({...item, nameGroup}))
//         return [{...data, nameGroup}, ...list]
//       }
//       return {...data, nameGroup}
//     }
//     let copyData = tree(data)
//     setNode(copyData)
//   }, [data])
//
//   const autoGroupColumnDef = {
//     headerName: "",
//     flex: 1,
//     minWidth: 400,
//     selectable: true,
//     resizable: true,
//     cellRendererParams: {
//       suppressCount: false,
//       suppressPadding: false,
//       innerRenderer: (params: any) => {
//         let {data, node} = params
//         return (
//           <>
//             {data?.data
//               ? <Group data={data}/>
//               : <Element data={data}/>
//             }
//           </>
//         )
//       }
//     }
//   };
//
//   const columnDefs = [
//     {field: 'glid', hide: true, disable: true}
//   ]
//
//   const defaultColDef = {
//     // skipHeader:true
//     // minWidth: 414,
//     // selectable: true,
//     // allowContextMenuWithControlKey: true,
//     // suppressMenu: false,
//     // sortable: false,
//     filter: true,
//     // resizable: true,
//     // getContextMenuItems: getContextMenuItems,
//   }
//
//   function getContextMenuItems(params: any) {
//     return contextMenu().map((itemMenu: any) => {
//       let {name, action, tooltip} = itemMenu
//       if (name === "-") return "separator"
//
//       return {
//         name: name,
//         action: () => action(params),
//         // cssClasses: [st.menuItem],
//         // tooltip
//       }
//     })
//   }
//
//   const gridOptions = {
//     defaultColDef: defaultColDef,
//     columnDefs: columnDefs,
//     headerHeight: 0,
//     groupDisplayType: "singleColumn",
//     debounceVerticalScrollbar: true,
//     autoGroupColumnDef: autoGroupColumnDef,
//     treeData: true,
//     animateRows: true,
//     groupDefaultExpanded: -1,
//     cacheQuickFilter: true,
//     rowSelection: 'multiple',
//   }
//
//   return (
//     <div className={st.container}>
//       <div className={st.finder}>
//         <div className={st.input}>
//           <img src={searchImg} className={st.svg}/>
//           <input type={"text"} placeholder={"Поиск"} className={st.search}
//                  onChange={(v: any) => setExternalFilter(v.target.value)}/>
//         </div>
//         <div className={st.icon}>
//           <img
//             src={settingsImg}
//             className={st.svg}
//             ref={settingIcon}
//             onClick={() => setActiveModal(true)}
//           />
//         </div>
//         {activeModal && <div className={st.modal}>
//           <ModalCard
//             header={"Настройки списка"}
//             oncancel={() => setActiveModal(false)}
//             onsave={() => ""}
//             style={{
//               width: 393,
//               height: 680,
//               top: 0,
//               left: "calc(100% + 12px)"
//             }}
//           >
//             список строк
//           </ModalCard>
//         </div>}
//
//       </div>
//
//       <div
//         className={cn("ag-theme-list", st.list)}
//       >
//         {/*@ts-ignore*/}
//         <AgGridReact
//           // @ts-ignore
//           ref={treeList}
//           rowData={nodes}
//           gridOptions={gridOptions}
//           getDataPath={(data: any) => data.nameGroup}
//           rowClass={st.row}
//           getContextMenuItems={getContextMenuItems}
//           isExternalFilterPresent={(params: any) => externalFilter}
//           doesExternalFilterPass={(params: any) => {
//             return (
//               params.data.name.indexOf(externalFilter) === 0 ||
//               params.data.glid.indexOf(externalFilter) === 0
//             )
//           }}
//           rowHeight={44}
//         />
//       </div>
//     </div>
//   )
// }, (prevProps: any, nextProps: any) => {
//   return false
//   // return prevProps.filters == nextProps.filters
//   //   || prevProps.fields == nextProps.fields
//   //   || prevProps.data == nextProps.data
// })
//
// export default TreeList;


//
// const filterHandler = (data: any): boolean => {
//   let bool = false
//   let intoObject = {}
//   fields.forEach((field: any) => {
//     let arrayFields = field.split(".")
//     arrayFields.forEach((item: any) => {
//       intoObject = data[item]
//       if (filters.includes(intoObject)) bool = true
//     })
//   })
//   return bool
// }


// const tree = (data: any,) => {
//   let {node} = data
//   index++
//   if (node?.data) {
//     // children || filterHandler(node) &&
//     return (
//       <>
//         <TreeGroup {...{...data, index}}>
//           {node.data.flatMap((item: any) => tree({...data, node: item, index}))}
//         </TreeGroup>
//       </>
//     )
//   }
//
//   if (filterHandler(node)) {
//     return [<TreeItem {...data} />]
//   }
//
//   return []
//
// }


// let tree = (data: any): any => {
//   let {nameGroup: copyNameGroup = []} = data
//   let nameGroup = [...copyNameGroup, data.glid]
//
//   if (data?.data) {
//     let list = data.data.flatMap((item: any) => tree({...item, nameGroup}))
//     return [{...data, nameGroup}, ...list]
//   }
//   return {...data, nameGroup}
// }
// let copyData = tree(data)
// setNode(copyData)